export default "__VITE_ASSET__CbYBSxjr__"